// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { ArgumentError } from "@lib/utilities/ArgumentError";
import { TypeUtility } from "@lib/utilities/TypeUtility";

/**
 * Provides methods for type checking arguments.
 */
export class ArgumentUtility
{
  static checkTypeIsArray(name: string, value: any): void
  {
    if (!TypeUtility.isArray(value))
      throw new ArgumentError("The specified value must be an array.", name);
  }

  static checkTypeIsBoolean(name: string, value: any): void
  {
    if (!TypeUtility.isBoolean(value))
      throw new ArgumentError("The specified value must be a boolean.", name);
  }

  static checkTypeIsClass(name: string, value: any, classFunction: new (...args: any[]) => any): void
  {
    if (!(value instanceof classFunction))
      throw new ArgumentError("The specified value must be an instance of the specified class.", name);
  }

  static checkTypeIsFunction(name: string, value: any): void
  {
    if (!TypeUtility.isFunction(value))
      throw new ArgumentError("The specified value must be a function.", name);
  }

  static checkTypeIsInteger(name: string, value: any): void
  {
    if (!TypeUtility.isInteger(value))
      throw new ArgumentError("The specified value must be a number.", name);
  }

  static checkTypeIsNumber(name: string, value: any): void
  {
    if (!TypeUtility.isNumber(value))
      throw new ArgumentError("The specified value must be a number.", name);
  }

  static checkTypeIsObject(name: string, value: any): void
  {
    if (!TypeUtility.isObject(value))
      throw new ArgumentError("The specified value must be an object.", name);
  }

  static checkTypeIsObjectAndNotNull(name: string, value: any): void
  {
    if (!TypeUtility.isObject(value) || TypeUtility.isNull(value))
      throw new ArgumentError("The specified value must be an object and not null.", name);
  }

  static checkTypeIsString(name: string, value: any): void
  {
    if (!TypeUtility.isString(value))
      throw new ArgumentError("The specified value must be a string.", name);
  }
}